import React, { useEffect, useState } from 'react'
import task from "../../../../assets/img/admin/task-square.svg"
import doc from "../../../../assets/img/admin/document-text.svg"
import Input from '../../../shared/Input'
import { useForm } from 'react-hook-form'
import Textarea from '../../../shared/Textarea'
import Button from '../../../shared/Button'
import useFetch from '../../../../hooks/useAxios'
import toast from 'react-hot-toast'
import Selectbox from '../../../shared/Select'
import AddFaqCat from './AddFaqCat'
import { useNavigate } from 'react-router-dom'
const AddFaqForm = () => {
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset
  } = useForm();
  const [faqdata, setfaqdata] = useState()
  const [FaqCat, setFaqCat] = useState()
  const [FaqCatvalue, setFaqCatvalue] = useState()
  const [FaqCatmodal, setFaqCatmodal] = useState()
  const navigate = useNavigate()
  const apiGetFAQ = useFetch({
    method: "post",
    url: "api/faqs",
    noHeader: false,
    trigger: false,
   data:faqdata,
    argFunc: res => {
     toast.success("عملیات با موفقیت انجام شد")
     navigate("/admin/Faq-list")
    }
  });
  const apiGetFAQCat = useFetch({
    method: "get",
    url: "api/faq_categories",
    noHeader: false,
    trigger: true,
   data:faqdata,
    argFunc: res => {
      setFaqCat(res.data.map(i=>({value:i.name,label:i.title})))
     toast.success("عملیات با موفقیت انجام شد")

    }
  });
  const onSubmit = (data)=>{
    if(FaqCatvalue === undefined){
      toast.error("لطفا دسته بندی را انتخاب کنید")
    }else{
      setfaqdata({...data ,category:FaqCatvalue })
      

    }
  }
  useEffect(() => {
   if(faqdata){
    apiGetFAQ.reFetch()
   }
  }, [faqdata])
  
  return (
    <div className='AddFaqForm'>
      <div>
      <div className='flex ResidenceHeader  justify-between items-center'>
        <h4 className='ResidenceHeader--h4'>اضافه کردن پرسش و پاسخ جدید</h4>
        <Button onClick={()=>setFaqCatmodal(true)} varient="Link"> +   افزودن دسته بندی </Button>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
      <div className='AddFaqForm--grid-3 '>
       <div >
        <label>
          <div className='flex gap-[8px] items-center'>
            <img src={doc} />
            <p>عنوان ســوال</p>

           
          </div>
        </label>
        <Input
            name="title"
            control={control}
            errors={errors}
            placeholder=" اطلاعاتی وارد نشده"
         
            className="admin-input my-[20px]"
            register={{
              required: "  عنوان اجباری است"
            }}
          />
        </div>
        <div>
        <label>
          <div className='flex gap-[8px] items-center'>
            <img src={task} />
            <p>دسته بندی محتوا</p>
          </div>
        </label>
        {/* <Input
            name="category"
            control={control}
            errors={errors}
            placeholder="اطلاعاتی وارد نشده"
            className="admin-input my-[20px]"
            register={{
              required: "  دسته بندی محتوا اجباری است"
            }}
          /> */}
         <div className='admin-select'>
           {FaqCat && <Selectbox value={FaqCatvalue} onChange={setFaqCatvalue} option={FaqCat} />}

          </div> 
        </div>
       </div>
       <Textarea
            name="description"
            control={control}
            errors={errors}
            label="متن مربوط به سوال متداول را وارد نمایید"
            className="admin-input my-[35px]"
            rows="5"
          />
          <Button fullwidth varient="primary">
              تـــایــیــد و آپــلـــود در ســایت
          </Button>
      </form>
      {
        FaqCatmodal && <AddFaqCat closeModal={()=>setFaqCatmodal(false)} apiCatlist={apiGetFAQCat}  />
      }

    </div>
  )
}

export default AddFaqForm